import React, { useEffect, useState } from "react";
import { CheckCircle2, Circle, Package, Truck, ClipboardCheck } from "lucide-react";
import api from "./api";

const STEPS = [
  { key: 1, label: "Sipariş Alındı", icon: ClipboardCheck },
  { key: 2, label: "Hazırlanıyor", icon: Package },
  { key: 3, label: "Hazır / Kargoya Veriliyor", icon: Package },
  { key: 4, label: "Kargoda", icon: Truck },
];

export default function TrackingPage({ token }) {
  const [order, setOrder] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/track/${token}`)
      .then(({ data }) => setOrder(data))
      .catch(() => setError("Sipariş bulunamadı"));
  }, [token]);

  return (
    <div style={styles.wrap} data-testid="tracking-page">
      <div style={styles.card}>
        <div style={styles.logo}>ZEN ERP</div>
        {error && <div style={styles.error} data-testid="tracking-error">{error}</div>}
        {!error && !order && <div style={styles.loading}>Yükleniyor...</div>}
        {order && (
          <>
            <div style={styles.orderNo} data-testid="tracking-order-no">{order.orderNo}</div>
            <div style={styles.statusBadge} data-testid="tracking-status">{order.statusLabel}</div>

            <div style={styles.stepper}>
              {order.status === "iptal" ? (
                <div style={{ color: "#FCA5A5", fontWeight: 700, textAlign: "center", padding: "12px 0" }}>Bu sipariş iptal edilmiştir</div>
              ) : STEPS.map((s, idx) => {
                const done = order.step >= s.key;
                const Icon = s.icon;
                return (
                  <div key={s.key} style={styles.stepRow}>
                    <div style={{ ...styles.stepIcon, ...(done ? styles.stepIconDone : {}) }}>
                      {done ? <CheckCircle2 size={20} color="#fff" /> : <Circle size={20} color="#94A3B8" />}
                    </div>
                    <span style={{ ...styles.stepLabel, ...(done ? styles.stepLabelDone : {}) }}>{s.label}</span>
                  </div>
                );
              })}
            </div>

            <div style={styles.itemsBox}>
              <div style={styles.itemsTitle}>Sipariş İçeriği</div>
              {(order.items || []).map((it, i) => (
                <div key={i} style={styles.itemRow}>
                  <span>{it.product}</span>
                  <span style={{ color: "#64748B" }}>{it.width}×{it.height} cm · {it.qty} adet</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrap: { minHeight: "100vh", background: "linear-gradient(160deg,#0A0C12,#12141E)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "Inter, sans-serif" },
  card: { width: "100%", maxWidth: 420, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 28, padding: 28, backdropFilter: "blur(20px)" },
  logo: { color: "#E5322A", fontWeight: 800, fontSize: 13, letterSpacing: 2, marginBottom: 18 },
  orderNo: { color: "#F5F6FA", fontSize: 24, fontWeight: 800 },
  statusBadge: { display: "inline-block", marginTop: 8, marginBottom: 24, padding: "6px 14px", borderRadius: 999, background: "rgba(52,211,153,0.15)", color: "#34D399", fontSize: 13, fontWeight: 700 },
  stepper: { display: "flex", flexDirection: "column", gap: 14, marginBottom: 24 },
  stepRow: { display: "flex", alignItems: "center", gap: 12 },
  stepIcon: { width: 34, height: 34, borderRadius: 17, background: "rgba(255,255,255,0.05)", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(255,255,255,0.1)" },
  stepIconDone: { background: "#E5322A", borderColor: "#E5322A" },
  stepLabel: { color: "rgba(245,246,250,0.4)", fontSize: 14, fontWeight: 600 },
  stepLabelDone: { color: "#F5F6FA" },
  itemsBox: { borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 16 },
  itemsTitle: { color: "rgba(245,246,250,0.5)", fontSize: 12, marginBottom: 10, textTransform: "uppercase", letterSpacing: 1 },
  itemRow: { display: "flex", justifyContent: "space-between", color: "#F5F6FA", fontSize: 13.5, marginBottom: 8 },
  error: { color: "#FCA5A5", textAlign: "center", padding: "20px 0" },
  loading: { color: "rgba(245,246,250,0.5)", textAlign: "center", padding: "20px 0" },
};
